module.exports = __webpack_public_path__ + "img/refresh-1.593d7f60.svg";